function getSelectedCurrency() {
  let cookies = document.cookie.split("; ");
  let currency = cookies.find((row) => row.startsWith("cart_currency="));
  return currency ? currency.split("=")[1] : "CAD";
}
console.log("load taper fuction");
function initTaperSelection() {
  let productForm = $("product-form");
  if (productForm.length) {
    let rawDataElement = $("#option-data");
    if (!rawDataElement.length) {
      return;
    }
    let rawData = rawDataElement.attr("data-json");
    try {
      let optionData = JSON.parse(rawData);
      let tapers = optionData.Tapers || [];
      let selectElement = $("select[name='properties[Taper]']");
      let container = $("#taperCardsContainer");
      if (!selectElement.length || !container.length) {
        return;
      }

      function getPriceFromDropdown(optionKey) {
        let currency = getSelectedCurrency();
        let option = selectElement.find(
          `option[data-option_value_key='${optionKey}']`
        );
        if (!option.length) return "N/A";
        let priceMatch = option
          .text()
          .match(
            currency === "CAD" ? /\[\+\$(.*?) CAD\]/ : /\[\+\$(.*?) USD\]/
          );
        return priceMatch ? priceMatch[1] : "N/A";
      }

      function updateTaperSelection() {
        let currency = getSelectedCurrency();
        container.empty();
        tapers.forEach((taper) => {
          let image_src =
            taper.image === ".jpg"
              ? "https://cdn.shopify.com/s/files/1/0730/1467/3625/files/taper_img.png?v=1737100293"
              : taper.image;
          let price = "";
          let fullprice = "";
          let value_key = "";
          if (currency == "CAD" && taper.cad.full != "") {
            price = getPriceFromDropdown(taper["data-option-value-key"]);
            value_key = taper["data-option-value-key"];
            fullprice = `<div class="sdt_fullPrice"><s>${taper.cad.full}</s></div>`;
          } else if (currency == "USD" && taper.us.full != "") {
            price = getPriceFromDropdown(taper["data-option-value-usa"]);
            value_key = taper["data-option-value-usa"];
            fullprice = `<div class="sdt_fullPrice"><s>${taper.us.full}</s></div>`;
          }

          let card = `
                    <div class="sdt_card" 
                        data-value="${taper.name}" 
                        data-option-value-key="${value_key}">
                        <img class="sdt_headerImg" src="${image_src}" alt="${taper.name}">
                        <div class="sdt_radioBtnContainer">
                            <div class="sdt_radio_icon"></div>
                            ${taper.name}
                        </div> 
                        <div class="sdt_discription">${taper.short}</div>
                        <div class="sdt_prices">
                          ${fullprice} 
                          <div class="sdt_salesPrice">$${price} </div>
                        </div>
                    </div>
                    `;
          container.append(card);
        });

        var $hiddenForm = $(".product-form form"); // Hidden SC Products form
        var $hiddenQuantityInput = $hiddenForm.find("input[name='quantity']");
        if (!$hiddenQuantityInput.length) {
          $hiddenQuantityInput = $("<input>", {
            type: "number",
            name: "quantity",
            value: 1,
          }).appendTo($hiddenForm);
        }

        $(".sdt_card").on("click", function () {
          $(".sdt_card").removeClass("active");
          $(this).addClass("active");
          let selectedKey = $(this).attr("data-option-value-key");
          let optionToSelect = selectElement.find(
            `option[data-option_value_key='${selectedKey}']`
          );
          if (optionToSelect.length) {
            selectElement
              .val(optionToSelect.val())
              .trigger("change")
              .trigger("input");
            selectElement[0].dispatchEvent(
              new Event("change", { bubbles: true })
            );
            selectElement[0].dispatchEvent(
              new Event("input", { bubbles: true })
            );
          }
        });

        let deluxeCard = $('.sdt_card[data-value="Deluxe"]');
        if (deluxeCard.length) {
          deluxeCard.trigger("click");
        }
      }
      console.log("runtaper function");
      updateTaperSelection();
      $(".cmc-or-ecd-controls").show();
    } catch (error) {}
  }
}

function checkModels() {
  console.log("load json");

  // Safely retrieve JSON from the data attribute
  const brandDataElement = $("#brand-data").attr("data-json");

  if (!brandDataElement) {
    console.log("Brand data attribute not found!");
    return;
  }

  let brandData;
  try {
    brandData = JSON.parse(brandDataElement);
    console.log("Parsed brandData:", brandData);

    if (!Array.isArray(brandData)) {
      console.error("Brand data is not an array! Check metafield structure.");
      return;
    }
  } catch (e) {
    console.error("Error parsing JSON:", e);
    return;
  }

  // Populate the brand dropdown

  var selectedBrand = getUrlParameter("brand");
  var selectedModel = getUrlParameter("model");
  var selectedModel_ = selectedModel; // raw version

  if (selectedBrand) {
    selectedBrand = selectedBrand.replace(/-/g, " ");
  }

  if (selectedModel) {
    selectedModel = selectedModel.replace(/-/g, " ");
  }

  //thecoverbrothers.ca/products/custom-spa-cover?brand=Amish-Country&model=Paradise
  https: $.each(brandData, function (index, brand) {
    $("#brand").append(
      $("<option>", {
        value: brand.brand,
        text: brand.brand,
      })
    );
  });

  // Handle brand selection
  $("#brand").on("change", function () {
    const selectedBrand = $(this).val();
    const modelDropdown = $("#model");

    $('input[name="properties[Make]"]')
      .val(selectedBrand)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event

    // Reset and disable the model dropdown
    modelDropdown
      .html('<option value="">Select Model</option>')
      .prop("disabled", true);
    $("#details").hide();

    if (selectedBrand) {
      // Find the selected brand
      const brand = brandData.find((b) => b.brand === selectedBrand);

      if (brand && Array.isArray(brand.models)) {
        // Populate the model dropdown
        $.each(brand.models, function (index, model) {
          modelDropdown.append(
            $("<option>", {
              value: model.name,
              text: model.name,
            })
          );
        });

        modelDropdown.prop("disabled", false);

        $("#model").val(selectedModel);
        if (!$("#model").val()) {
          $("#model").val(selectedModel_);
        }

        $("#model").trigger("change");
      }
    }
  });

  // Handle model selection
  $("#model").on("change", function () {
    const selectedBrand = $("#brand").val();
    const selectedModel = $(this).val();

    $('input[name="properties[model]"]')
      .val(selectedModel)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event

    if (selectedBrand && selectedModel) {
      // Find the selected brand and model
      const brand = brandData.find((b) => b.brand === selectedBrand);
      const model = brand.models.find((m) => m.name === selectedModel);

      if (model) {
        // Display shape
        $("#shape").text(model.shape);

        // Display measurements
        const measurementsList = $("#measurements");
        measurementsList.empty();
        $.each(model.measurements, function (key, value) {
          measurementsList.append(`<li>${key.toUpperCase()}: ${value}</li>`);
          $(".input-" + key + "-value").val(value);
        });

        $('input[name="properties[Shape]"]')
          .val(model.shape)
          .trigger("change") // Notify Shopify/SC Product Options
          .trigger("input"); // Some themes require an input event

        console.log("model.shape:" + model.shape);
        $('.shape-button[data-shape="' + model.shape + '"]').click();

        setTimeout(() => {
          $('.shape-button[data-shape="' + model.shape + '"]').click();
          console.log("✅ Clicked shape button after delay:", model.shape);
        }, 1000); // 1000ms (1 second) delay
      }
    } else {
      $("#details").hide();
    }
  });

  $("#brand").val(selectedBrand);
  $("#brand").trigger("change");
}

$(document).ready(function () {
  console.log("Wait for product-form to load before running the script");
  let checkFormInterval = setInterval(() => {
    console.log(
      "check bold_option_textbox :" + $(".bold_option_textbox ").length
    );
    if ($(".bold_option_textbox ").length > 3) {
      clearInterval(checkFormInterval);
      initTaperSelection();
      checkModels();
    }
  }, 500);

  console.log("load json");

  $(".step-2-show").click(function (event) {
    event.preventDefault(); // Prevent default link behavior (if <a> tag is used)

    console.log("next-step");

    // Hide the first step
    $("#custom_step_01").hide();
    $(
      "#shopify-section-template--20789040349389__home_section_16_CynDdC"
    ).hide();
    $(
      "#shopify-section-template--20789040349389__home_section_10_K7y3QD "
    ).hide();
    $(
      "#shopify-section-template--20789040349389__home_section_6_A9JJGF"
    ).hide();

    // Show the second step
    $("#custom_step_02").show();

    // 🚀 Smooth Scroll to the Top of Step 2
    $("html, body").animate(
      {
        scrollTop: $("#customizer").offset().top,
      },
      600
    ); // Adjust speed (600ms = smooth)

    let leftOffsetPosition = $(".custom_step_02_left_offset").offset().top;
    let rightHeight = $(".custom_step_02_right").outerHeight();
    let offsetHeight = $(".custom_step_02_left_offset").outerHeight();

    $(window).scroll(function () {
      let scrollTop = $(window).scrollTop();

      if (scrollTop > leftOffsetPosition - 200) {
        offset = scrollTop - leftOffsetPosition + 200;
        if (offset < 100) {
          offset = 100;
        }
        let travelArea = rightHeight - offsetHeight;
        if (travelArea < offset) {
          offset = travelArea;
        }
        $(".custom_step_02_left_offset").css("top", offset + "px");
      }
    });
  });

  $(".next-step-btn").on("click", function () { 
    console.log('test')
    let currentStep = parseInt($(this).attr("current-step"));
    let isValid = true;
    let errorMessage = "";

    // 🚀 Reset error message before validation
    $(".errorMessage").empty();

    // 🚀 STEP 2 VALIDATION
    if (currentStep === 2) {
      if ($(".shape-button.active").length === 0) {
        isValid = false;
        errorMessage += "❌ Please select a shape.<br>";
      }

      $(".emu-dimension-option:visible .emu-dimension-input").each(function () {
        if ($(this).val().trim() === "") {
          isValid = false;
          errorMessage += "❌ Please fill all measurement fields.<br>";
          return false;
        }
      });

      if (!$(".emu-confirmation-checkbox").prop("checked")) {
        isValid = false;
        errorMessage +=
          "❌ Please confirm your measurements by checking the box.<br>";
      }

      // ✅ Ensure all required dropdowns are selected
      const requiredDropdowns = [
        { selector: ".fsk-fold-direction", name: "Cover Fold Direction" },
        { selector: ".fsk-slocation", name: "Strap Location" },
        { selector: ".fsk-skirt-length", name: "Skirt Length" },
      ];

      requiredDropdowns.forEach((dropdown) => {
        if (
          $(dropdown.selector).val().trim() === "" ||
          $(dropdown.selector).val().trim() === "" ||
          $(dropdown.selector).val().trim() === ""
        ) {
          isValid = false;
          errorMessage += `❌ Please select ${dropdown.name}.<br>`;
        }
      });

      $("html, body").animate(
        {
          scrollTop: $("#customizer").offset().top,
        },
        600
      ); // Adjust speed (600ms = smooth)

      if (!isValid) {
        $(".errorMessage").html(errorMessage).css("color", "red");
        return;
      }

      // ✅ Hide Step 2 & Show Step 3
      $("#custom_step_02").hide();
      $("#custom_step_03").show();
    }

    // 🚀 STEP 3 VALIDATION
    if (currentStep === 3) {
      if ($(".color-button.selected").length === 0) {
        isValid = false;
        errorMessage += "❌ Please select a color.<br>";
      }

      if ($(".shw_card.active").length === 0) {
        isValid = false;
        errorMessage +=
          "❌ Please select an option from the upgrades & accessories.<br>";
      }

      $("html, body").animate(
        {
          scrollTop: $("#customizer").offset().top,
        },
        600
      ); // Adjust speed (600ms = smooth)

      if (!isValid) {
        $(".errorMessage").html(errorMessage).css("color", "red");
        return;
      }

      // ✅ Hide Step 3 & Show Step 4
      $("#custom_step_03").hide();
      $("#custom_step_04").show();
      $("#ugw_popup").removeClass("is-open").hide();
      $("#color-popup").hide();
    }

    // 🔄 Increase current step number
    $(".next-step-btn").attr("current-step", currentStep + 1);

    $(document)
    .off("click.hideUgwPopupOnContinue")
    .on("click.hideUgwPopupOnContinue", ".next-step-btn", function () {
      $("#ugw_popup").removeClass("is-open").hide();
      $("#color-popup").hide();
    });
  });

  $(".custom-add-to-cart").click(function () {
    $(".product-form__submit.bold_hidden").trigger("click");
  });

  // Safely retrieve JSON from the data attribute
  const brandDataElement = $("#brand-data").attr("data-json");

  if (!brandDataElement) {
    console.error("Brand data attribute not found!");
    return;
  }

  let brandData;
  try {
    brandData = JSON.parse(brandDataElement);

    if (!Array.isArray(brandData)) {
      console.error("Brand data is not an array! Check metafield structure.");
      return;
    }
  } catch (e) {
    console.error("Error parsing JSON:", e);
    return;
  }

  // Populate the brand dropdown
  $.each(brandData, function (index, brand) {
    $("#brand").append(
      $("<option>", {
        value: brand.brand,
        text: brand.brand,
      })
    );
  });

  // Handle brand selection
  $("#brand").on("change", function () {
    const selectedBrand = $(this).val();
    const modelDropdown = $("#model");

    $('input[name="properties[Make]"]')
      .val(selectedBrand)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event

    // Reset and disable the model dropdown
    modelDropdown
      .html('<option value="">Select Model</option>')
      .prop("disabled", true);
    $("#details").hide();

    if (selectedBrand) {
      // Find the selected brand
      const brand = brandData.find((b) => b.brand === selectedBrand);

      if (brand && Array.isArray(brand.models)) {
        // Populate the model dropdown
        $.each(brand.models, function (index, model) {
          modelDropdown.append(
            $("<option>", {
              value: model.name,
              text: model.name,
            })
          );
        });

        modelDropdown.prop("disabled", false);
      }
    }
  });

  // Handle model selection

  $("#model").on("change", function () {
    const selectedBrand = $("#brand").val();
    const selectedModel = $(this).val();

    $('input[name="properties[model]"]')
      .val(selectedModel)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event

    if (selectedBrand && selectedModel) {
      // Find the selected brand and model
      const brand = brandData.find((b) => b.brand === selectedBrand);
      const model = brand
        ? brand.models.find((m) => m.name === selectedModel)
        : null;

      if (model) {
        // Display shape
        $("#shape").text(model.shape);

        // Update the shape in Shopify properties
        $('input[name="properties[Shape]"]')
          .val(model.shape)
          .trigger("change")
          .trigger("input");

        // Clear previous measurements
        $("#measurements").empty();

        // Update each dimension input field dynamically
        $.each(model.measurements, function (key, value) {
          $("#measurements").append(`<li>${key.toUpperCase()}: ${value}</li>`);

          // Find the corresponding input field and update its value
          $(`input[name="properties[Dimension ${key.toUpperCase()}]"]`)
            .val(value)
            .trigger("change")
            .trigger("input"); // Ensure Shopify recognizes the change
        });

        // Trigger click on the matching shape button
        $('.shape-button[data-shape="' + model.shape + '"]').click();

        // Show details if needed
        $("#details").show();
      }
    } else {
      $("#details").hide();
    }
  });
});

jQuery(document).ready(function () {
  jQuery("form.form").on(
    "change input",
    "input, select, textarea",
    function () {
      // Get the updated form value
      const updatedValue = jQuery(this).val();

      // Get the content of the span
      const spanContent = jQuery(".bold_option_total span").text();
      // Example: Perform a calculation or update another element

      jQuery(".pct_total_price").text(spanContent);
    }
  );

  $(".fsk-fold-direction").on("change", function () {
    var fd = $(this).val();

    $(".shape-mask").attr("fold", fd);
    $(".fold-line").attr("fold", fd);
    showtags();

    var aImg = $(".shape.active").attr("a-img");
    var bImg = $(".shape.active").attr("b-img");

    if (fd == "fold-b") {
      $(".fsk-dimension-right-image").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0575/" + bImg
      );
    } else {
      $(".fsk-dimension-right-image").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0575/" + aImg
      );
    }
  });

  $(".fsk-slocation").on("change", function () {
    showtags();
  });
});

function showtags() {
  let fl = $(".fsk-slocation").val();
  if (!fl) {
    console.log("show-all");
    $(".tag").show();
  } else {
    $(".tag").hide();
    let letter = fl.split("-")[1];
    console.log("show-" + letter);
    $("." + letter + "-tag").show();
  }
}

// pull dynamic pricing
$(document).ready(function () {
  function updateDropdownPrices() {
    let countrySelect = $("select[name='country_code']");
    let shopifyStrapSelect = $("select[name='properties[Strap Option]']"); // The Shopify dropdown
    let fskStrapSelect = $(".fsk-dropdown-input.fsk-strap-count"); // Custom dropdown

    if (shopifyStrapSelect.length && fskStrapSelect.length) {
      shopifyStrapSelect.find("option").each(function () {
        let optionText = $(this).text().trim();
        let keyValue = $(this).attr("data-option_value_key"); // Get option key

        // Extract price using Regex
        let priceMatch = optionText.match(/\[\+\$(.*?)\s(CAD|USD)\]/);

        if (priceMatch) {
          let extractedPrice = priceMatch[1]; // Extract only price value (e.g., "14.95")
          let currency = priceMatch[2]; // Extract currency (CAD or USD)

          // Find matching option in the custom dropdown and update text
          let matchingOption = fskStrapSelect.find(
            `option[value='${keyValue}']`
          );
          if (matchingOption.length) {
            let optionLabel = matchingOption.text().split(" (+$")[0]; // Remove old price if exists
            matchingOption.text(
              `${optionLabel} (+$${extractedPrice} ${currency})`
            );
          }
        }
      });
    } else {
      console.warn("⚠️ Shopify Strap Option or Custom Dropdown not found.");
    }
  }

  // Wait for product-form to load before running the script
  let observer = new MutationObserver(function (mutations, observer) {
    if ($("product-form").length) {
      observer.disconnect();
      updateDropdownPrices();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Fallback: Run function after a delay in case MutationObserver fails
  setTimeout(() => {
    if ($("product-form").length) {
      updateDropdownPrices();
    }
  }, 4000);
});

$(document).ready(function () {
  function updateSkirtDropdownPrices() {
    let shopifySkirtSelect = $("select[name='properties[Skirt Length]']"); // Shopify Skirt Length dropdown
    let fskSkirtSelect = $(".fsk-dropdown-input.fsk-skirt-length"); // Custom Skirt Length dropdown

    if (shopifySkirtSelect.length && fskSkirtSelect.length) {
      shopifySkirtSelect.find("option").each(function () {
        let optionText = $(this).text().trim();
        let keyValue = $(this).attr("data-option_value_key"); // Get option key

        // Extract price using Regex
        let priceMatch = optionText.match(/\[\+\$(.*?)\s(CAD|USD)\]/);

        if (priceMatch) {
          let extractedPrice = priceMatch[1]; // Extract only price value (e.g., "14.95")
          let currency = priceMatch[2]; // Extract currency (CAD or USD)

          // Find matching option in the custom dropdown and update text
          let matchingOption = fskSkirtSelect.find(
            `option[value='${keyValue}']`
          );
          if (matchingOption.length) {
            let optionLabel = matchingOption.text().split(" (+$")[0]; // Remove old price if exists
            matchingOption.text(
              `${optionLabel} (+$${extractedPrice} ${currency})`
            );
          }
        }
      });
    } else {
      console.warn(
        "⚠️ Shopify Skirt Length Option or Custom Dropdown not found."
      );
    }
  }

  // Wait for the product form to load before running the script
  let observer = new MutationObserver(function (mutations, observer) {
    if ($("product-form").length) {
      observer.disconnect();
      updateSkirtDropdownPrices();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Fallback: Run function after a delay if MutationObserver fails
  setTimeout(() => {
    if ($("product-form").length) {
      updateSkirtDropdownPrices();
    }
  }, 4000);
});

$(document).ready(function () {
  const savedShape = localStorage.getItem("selectedShape");
  $(".shape svg").css("stroke", "#ccc");

  if (savedShape) {
    $(`.shape[data-shape="${savedShape}"] svg`).css("stroke", "#198ABD");
    $("#selected-shape").text(savedShape);
  }

  $(".shape").on("click", function () {
    // Reset stroke for all shapes
    $(".shape").removeClass("active");
    $(this).addClass("active");
    $(".shape svg").css("stroke", "#ccc");

    // Highlight the selected shape
    $(this).find("svg").css("stroke", "#198ABD");

    // Get the selected shape's name
    const shapeName = $(this).data("shape");
    console.log("shapeName:" + shapeName);

    if (shapeName == "rounded-square" || shapeName == "square") {
      $(".discription-square").show();
    } else {
      $(".discription-square").hide();
    }

    // Update the display text

    $(".shape-text-display-shape").empty().append(shapeName);

    var df = $(this).attr("fold-d");
    var aImg = $(this).attr("a-img");
    var bImg = $(this).attr("b-img");
    var foldDirection = $(".fsk-fold-direction").val();

    if (df == 1) {
      $("option.fold-b").hide();
      foldDirection = "fold-a";
      $(".fsk-dimension-right-image").val("fold-a");
    } else {
      $("option.fold-b").show();
    }

    let strapHide = $(this).attr("strap-hide");
    $(".fsk-slocation option").show();

    if (strapHide) {
      // Convert the string into an array of letters
      let letters = strapHide.split("");

      // Loop through each letter and hide the corresponding "sl-" class
      letters.forEach(function (letter) {
        $(".sl-" + letter).hide();
      });

      console.log("Hiding classes:", letters.map((l) => "sl-" + l).join(", "));
    }

    if (foldDirection == "fold-b") {
      $(".fsk-dimension-right-image").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0575/" + bImg
      );
    } else {
      $(".fsk-dimension-right-image").attr(
        "src",
        "https://cdn.shopify.com/s/files/1/0575/" + aImg
      );
    }

    //set form
    $('input[name="properties[Shape]"]').val(shapeName);

    let sCount = parseInt($(this).attr("speakers")) || null; // Get the "speakers" attribute as an integer or null
    console.log("Speakers count:", sCount);

    //set form
    let pShape = $(this).attr("pshape") || null; // Get the "pShape" attribute as an integer or null
    console.log("pShape:" + pShape);

    let selectedValueKey = "";
    if (pShape) {
      $('input[name="properties[Shape]"]').val("");
      selectedValueKey = pShape;
    } else {
      $('input[name="properties[Shape]"]').val(shapeName);
      selectedValueKey = "None";
    }

    console.log("selectedValueKey:" + selectedValueKey);

    selectElement = $('select[name="properties[Premium Shape]"]');

    if (selectedValueKey !== "None") {
      let optionToSelect = selectElement.find(
        `option[data-option_value_key='${selectedValueKey}']`
      );

      if (optionToSelect.length) {
        selectElement
          .val(optionToSelect.val())
          .trigger("change")
          .trigger("input");

        // 🚀 Force Shopify & SC Product Options to recalculate with slight delay
        setTimeout(() => {
          selectElement[0].dispatchEvent(
            new Event("change", { bubbles: true })
          );
          selectElement[0].dispatchEvent(new Event("input", { bubbles: true }));
        }, 100);

        console.log("Dropdown updated to:", optionToSelect.val());
      } else {
        console.warn("No matching option found in dropdown.");
      }
    } else {
      // Reset dropdown to None if speakers count is missing
      selectElement.val("").trigger("change").trigger("input");

      setTimeout(() => {
        selectElement[0].dispatchEvent(new Event("change", { bubbles: true }));
        selectElement[0].dispatchEvent(new Event("input", { bubbles: true }));
      }, 100);

      console.warn("Speakers count not found. Resetting dropdown.");
    }
  });

  $(".input-a-value").change(function () {
    var inches = $(this).val();
    $('input[name="properties[Dimension A]"]')
      .val(inches)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event
  });

  $(".input-b-value").change(function () {
    var inches = $(this).val();
    $('input[name="properties[Dimension B]"]')
      .val(inches)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event
  });

  $(".input-c-value").change(function () {
    var inches = $(this).val();
    $('input[name="properties[Dimension C]"]')
      .val(inches)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event
  });

  $(".input-d-value").change(function () {
    var inches = $(this).val();
    $('input[name="properties[Dimension D]"]')
      .val(inches)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event
  });

  $(".input-e-value").change(function () {
    var inches = $(this).val();
    $('input[name="properties[Dimension E]"]')
      .val(inches)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event
  });

  $(".input-f-value").change(function () {
    var inches = $(this).val();
    $('input[name="properties[Dimension F]"]')
      .val(inches)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event
  });

  $(".fsk-fold-direction").change(function () {
    var inches = $(this).val();
    $('input[name="properties[Cover Fold Direction]"]')
      .val(inches)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event
  });

  $(".fsk-slocation").change(function () {
    var inches = $(this).val();
    $('input[name="properties[Strap Location]"]')
      .val(inches)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event
  });

  $(".fsk-skirt-length").change(function () {
    var selectedKey = $(this).val();

    console.log("Strap count selected: " + selectedKey);

    let selectElement = $("select[name='properties[Skirt Length]']");
    let optionToSelect = selectElement.find(
      `option[data-option_value_key='${selectedKey}']`
    );

    if (optionToSelect.length) {
      selectElement
        .val(optionToSelect.val())
        .trigger("change")
        .trigger("input");

      // 🚀 Force Shopify & SC Product Options to recalculate
      selectElement[0].dispatchEvent(new Event("change", { bubbles: true }));
      selectElement[0].dispatchEvent(new Event("input", { bubbles: true }));

      console.log("Dropdown updated to:", optionToSelect.val());
    } else {
      console.warn("No matching option found in dropdown.");
    }
  });
});

$(document).ready(function () {
  function updateColourButtonsWithPrices() {
    let shopifyColourSelect = $("select[name='properties[Colours]']"); // Shopify Colour dropdown

    if (shopifyColourSelect.length) {
      console.log("🛠 Checking Colour Options for Prices...");

      shopifyColourSelect.find("option").each(function () {
        let optionText = $(this).text().trim();
        let keyValue = $(this).attr("data-option_value_key"); // Extracts the key

        // Extract price using Regex
        let priceMatch = optionText.match(/\[\+\$(.*?)\s(CAD|USD)\]/);

        if (priceMatch) {
          let extractedPrice = priceMatch[1]; // Extract price value (e.g., "14.95")
          let currency = priceMatch[2]; // Extract currency (CAD or USD)

          console.log(
            `💲 Colour with Price: ${optionText} → $${extractedPrice} ${currency}`
          );

          // ✅ Find and update the matching `.color-button` text
          let matchingButton = $(`.color-button[value='${keyValue}']`);
          if (matchingButton.length) {
            let originalText = matchingButton.text().split(" (+$")[0]; // Remove old price if exists
            matchingButton.text(
              `${originalText} (+$${extractedPrice} ${currency})`
            );

            console.log(
              `✅ Updated Colour Button: ${originalText} → ${matchingButton.text()}`
            );
          } else {
            console.warn(
              `⚠️ No matching color button found for value: ${keyValue}`
            );
          }
        }
      });
    } else {
      console.warn("⚠️ Shopify Colour Option dropdown not found.");
    }
  }

  // Wait for the product form to load before running the script
  let observer = new MutationObserver(function (mutations, observer) {
    if ($("product-form").length) {
      observer.disconnect();
      updateColourButtonsWithPrices();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Fallback: Run function after a delay if MutationObserver fails
  setTimeout(() => {
    if ($("product-form").length) {
      console.log("🚀 Running fallback check for Colour prices...");
      updateColourButtonsWithPrices();
    }
  }, 3000);
});

$(document).ready(function () {
  $(".color-button").on("click", function () {
    // Remove 'selected' class from all buttons and add it to the clicked one
    $(".color-button").removeClass("selected");
    $(this).addClass("selected");

    // Get background image and extract the URL
    let backgroundImage = $(this).css("background-image");
    let imageUrl = backgroundImage
      .replace(/^url\(["']?/, "")
      .replace(/["']?\)$/, ""); // Remove `url("")` wrapping

    console.log("🎨 Selected Color Button Background Image:", imageUrl);

    // Set extracted image URL to the .shape-image element
    $(".shape-image").attr("src", imageUrl);

    // Get the selected color's value and dText (if applicable)
    let selectedValue = $(this).attr("value");
    let selectedText = $(this).attr("dText") || $(this).text().trim();

    // Update the displayed text
     selectedText = (selectedText || "").replace(/_/g, " ");
    $(".dtext_target").text(selectedText);

    // Find the matching option in the Shopify dropdown by data-option_value_key
    let selectElement = $("select[name='properties[Colours]']");
    let optionToSelect = selectElement.find(
      `option[data-option_value_key='${selectedValue}']`
    );

    if (optionToSelect.length) {
      selectElement
        .val(optionToSelect.val())
        .trigger("change")
        .trigger("input");

      // 🚀 Force Shopify & SC Product Options to recognize the change
      selectElement[0].dispatchEvent(new Event("change", { bubbles: true }));
      selectElement[0].dispatchEvent(new Event("input", { bubbles: true }));

      console.log("Color selection updated:", selectedText);
    } else {
      console.warn("No matching option found for value:", selectedValue);
    }
  });
});

$(document).ready(function () {
  $(".liner-button").on("click", function () {
    // Remove 'selected' class from all buttons and add it to the clicked one
    $(".liner-button").removeClass("selected");
    $(this).addClass("selected");

    // Get the selected color's value and dText (if applicable)
    let selectedValue = $(this).attr("value");
    let selectedText = $(this).attr("dText") || $(this).text().trim();

    $('input[name="properties[Liner Color]"]')
      .val(selectedText)
      .trigger("change") // Notify Shopify/SC Product Options
      .trigger("input"); // Some themes require an input event

    // Update the displayed text
    $(".liner-dtext_target").text(selectedText);
  });
});

$(document).ready(function () {
  // Extract JSON from the data attribute
  let optionData = $("#option-data").attr("data-json");

  let jsonData = JSON.parse(optionData); // Parse JSON string
  let handlesData = jsonData.Handles || []; // Ensure Handles exist
  let currency = getSelectedCurrency();

  // Clear existing options
  $(".handle-options-container").empty();

  // Loop through each handle option and create the corresponding HTML
  handlesData.forEach((handle, index) => {
    let handlePrice = "";
    let value_key = "";

    if (currency == "CAD") {
      value_key = handle.value;
      handlePrice = handle.cad.sale;
    } else if (currency == "USD") {
      value_key = handle.value_usa;
      handlePrice = handle.us.sale;
    }

    let handleImage =
      handle.image !== ".jpg"
        ? `${handle.image}`
        : "https://cdn.shopify.com/s/files/1/0730/1467/3625/files/taper_img_1.png?v=1737347233";

    let handleCard = `
            <div class="shw_card" id="shwc_${index}" data-option_value_key="${value_key}" data-name="${handle.name}">
                <img
                    class="shw_headerImg"
                    src="${handleImage}"
                    alt="${handle.name}"
                >
                <div class="shw_radioBtnContainer">
                    <div class="shw_radio_icon"></div>
                    ${handle.name}
                </div>
                <div class="shw_discription">${handle.short}</div>
                <div class="shw_prices">
                    <div class="shw_salesPrice">${handlePrice}</div>
                </div>
            </div>
        `;

    // Append each handle card to the container
    $(".shw_cardContainer").append(handleCard);
  });

  // Set the first handle as active

  $(document).on("click", ".shw_card", function () {
    let addSelection = $(this);
    let activeIds = $(".shw_card.active")
      .map(function () {
        return this.id;
      })
      .get();

    console.log(activeIds); // Output the active IDs

    let selectionId = addSelection.attr("id"); // Get clicked element ID

    if (activeIds.includes(selectionId)) {
      if (selectionId === "shwc_0" || selectionId === "shwc_1") {
        addSelection.removeClass("active");
        $("#shwc_2").removeClass("active");
      } else if (selectionId === "shwc_2") {
        addSelection.removeClass("active");
      }
    } else {
      if (selectionId === "shwc_0" && activeIds.includes("shwc_1")) {
        $("#shwc_0").addClass("active");
        $("#shwc_1").removeClass("active");
      } else if (selectionId === "shwc_1" && activeIds.includes("shwc_0")) {
        $("#shwc_1").addClass("active");
        $("#shwc_0").removeClass("active");
      } else {
        addSelection.addClass("active");
      }
    }

    let selectedHandles = [];

    // Collect all active handles
    $(".shw_card.active").each(function () {
      let handleName = $(this).data("option_value_key");

      selectedHandles.push(handleName); // Store selected names
    });

    console.log("Selected Handles:", selectedHandles);

    // Set the input field value
    let inputField = $("input[name='properties[Handles]']");
    inputField
      .val(selectedHandles.join(", "))
      .trigger("change")
      .trigger("input");

    // Uncheck all checkboxes first

    $(".cbm_2225867_857370").each(function () {
      let checkbox = $(this);

      if (!selectedHandles.includes(checkbox.val())) {
        checkbox.prop("checked", false);
        checkbox
          .trigger("change")
          .trigger("input")[0]
          .dispatchEvent(new Event("change", { bubbles: true }));
        checkbox[0].dispatchEvent(new Event("input", { bubbles: true }));
      }
    });

    // Check the checkboxes that match the selected handles
    selectedHandles.forEach(function (handleValue) {
      let inputActive = $(
        '.cbm_2225867_857370[data-option_value_key="' + handleValue + '"]'
      );
      inputActive.prop("checked", true);
      inputActive
        .trigger("change")
        .trigger("input")[0]
        .dispatchEvent(new Event("change", { bubbles: true }));
      inputActive[0].dispatchEvent(new Event("input", { bubbles: true }));
    });
  });
});


$(document)
  .off("submit", ".form")
  .on("submit", ".form", function (event) {
    event.preventDefault();

    if (!$(this).find('[name="id"]').val()) {
      console.error("Missing product ID!");
      return;
    }

    if (!$(this).find('[name="quantity"]').val()) {
      $(this).find('[name="quantity"]').val("1");
    }

    console.log("FormData:", $(this).serialize());

    $.post($(this).attr("action"), $(this).serialize())
      .done((response) => {
        console.log("✅ Success:", response);
        window.location.href = window.location.pathname + "?openCart=1";
      })
      .fail((error) => {
        console.error("❌❌❌ Error:", error);
      });
  });

$(document).ready(function () {
  console.log("openCart: " + getUrlParameter("openCart"));

  if (getUrlParameter("openCart") == "1") {
    const $cartDrawer = $("cart-drawer.drawer");
    if ($cartDrawer.length) {
      console.log("🛒 Opening cart drawer after 3 seconds active...");

      // ✅ Add the 'active' class to open the drawer
      $cartDrawer.addClass("active");

      // ✅ Focus on the cart drawer for better UX
      $cartDrawer.focus();
    }
  }
});

function getUrlParameter(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

$(document).ready(function () {
  // Open popup when clicking on the popup link
  $(document).on("click", ".ugw_popup_link", function (event) {
    event.stopPropagation(); // Prevent triggering body click
    console.log("popup clicked");
    let parentCard = $(this).closest(".ugw_card");

    let imageSrc = parentCard.find("img.ugw_headerImg").attr("src");
    let name = parentCard.find(".ugw_name").text();
    let description = parentCard.find(".ugw_discription_long").text();

    $("#ugw_popup_image").attr("src", imageSrc);
    $("#ugw_popup_name").text(name);
    $("#ugw_popup_description").text(description);

    $("#ugw_popup").fadeIn();
    $("#ugw_popup").addClass("is-open").show();
  });

  // Close popup when clicking close button
  $(document).on("click", ".ugw_close", function () {
    $("#ugw_popup").fadeOut();
    $("#ugw_popup").removeClass("is-open").hide();
  });

  // Close popup when clicking outside the popup content
  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(".ugw_popup_content").length &&
      $("#ugw_popup").is(":visible")
    ) {
      $("#ugw_popup").fadeOut();
    }
  });

  // Extract JSON from the data attribute
  let optionData = $("#option-data").attr("data-json");

  if (optionData) {
    try {
      let jsonData = JSON.parse(optionData); // Parse JSON string
      let accessoriesData = jsonData.Assessories || []; // Ensure Accessories exist

      // Clear existing options before inserting new ones
      $(".ugw_cardContainer").empty();

      // Loop through each accessory option and create the corresponding HTML
      accessoriesData.forEach((accessory, index) => {
        // Skip accessories where status is 0
        if (accessory.status === 0) {
          return; // Skip this iteration
        }

        let currency = getSelectedCurrency();
        let price = "";

        if (currency == "CAD") {
          price = accessory.cad.sale;
          key_value = 1;
        } else if (currency == "USD") {
          price = accessory.us.sale;
          key_value = 2;
        }
        if (price == "") {
          return; // Skip this iteration
        }

        let image_src =
          accessory.image !== ".jpg"
            ? `${accessory.image}`
            : "https://cdn.shopify.com/s/files/1/0730/1467/3625/files/taper_img_1.png?v=1737347233"; // Ensure price is formatted

        let accessoryCard = `
                    <div class="ugw_card" data-option_value_key="${key_value}" data-accessory="${accessory.value}">
                        <img
                            class="ugw_headerImg"
                            src="${image_src}"
                            alt="${accessory.name}"
                        >
                        <div class="ugw_radioBtnContainer">
                            <div class="ugw_radio_icon"></div>
                            <div class="ugw_name">${accessory.name}</div>
                        </div>
                        <div class="ugw_discription">${accessory.short}</div>
                        <div class="ugw_discription_long">${accessory.long}</div>
                        <div class="ugw_prices">
                            <div class="ugw_salesPrice">${price}</div>
                        </div>
                        <div class="ugw_popup_link">
                          <div class="emu-link-icon"></div>
                        </div>
                    </div>
                `;

        // Append each accessory card to the container
        $(".ugw_cardContainer").append(accessoryCard);
      });

      // 🚀 Delegate event to dynamically generated elements
      $(document).on("click", ".ugw_card", function () {
        let accessoryFieldName = $(this).attr("data-accessory").trim();
        let selectElement = $(`select[name='${accessoryFieldName}']`);

        if (!selectElement.length) {
          console.warn(`Dropdown not found for: ${accessoryFieldName}`);
          return;
        }

        // Toggle active state
        $(this).toggleClass("active");

        let newValue = "";
        if ($(this).hasClass("active")) {
          let optionKey = $(this).data("option_value_key");
          let matchingOption = selectElement.find(
            `option[data-option_value_key='${optionKey}']`
          );
          if (matchingOption.length) {
            newValue = matchingOption.val();
          } else {
            console.warn(
              `No matching option for data-option_value_key="${optionKey}"`
            );
          }
        }

        selectElement.val(newValue).trigger("change").trigger("input");

        // Force Shopify & SC Product Options to recognize the change
        selectElement[0].dispatchEvent(new Event("change", { bubbles: true }));
        selectElement[0].dispatchEvent(new Event("input", { bubbles: true }));

        console.log(
          `✅ ${accessoryFieldName} selection updated to: ${newValue}`
        );
      });

      // 🚀 Ensure Shopify Prices Load Correctly
      let observer = new MutationObserver(function (mutations, observer) {
        if ($("product-form").length) {
          observer.disconnect();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    } catch (error) {
      console.error("❌ Error parsing JSON:", error);
    }
  } else {
    console.warn("⚠️ No option data found.");
  }
});
